import { clearLocalStorage } from "../../../helpers/localStorage"
import { logout, unwrapDataError } from "../../apis/axios"
import { Group } from "../groups/group"
import { Promotion } from "../promotions/promotion"
import { Role, getUserHasHierarchyRole, getUserHasRole } from "./role"


export interface user {
    id: number
    userName: string
    password?: string
    email: string
    groups: Group[]
    roles: Role[]
    hierarchyRoles: Role[]
    isDeleted: boolean
}

export function getCanEdit(user: user): boolean {
  if (user.roles === undefined || user.roles === null)
    return false

  return getUserHasRole(user, "Editor");
}

export function getCanPromote(user: user, promotion: Promotion): boolean {
  return getUserHasHierarchyRole(user, promotion.approver)
}

export function getCanReject(user: user | undefined | null, promotion: Promotion): boolean {
  if (user === undefined || user === null)
    return false

  return (
      getCanPromote(user, promotion)
  )
}

export function getCanApprove(user: user | undefined | null, promotion: Promotion): boolean {
  if (user === undefined || user === null)
    return false

  return getCanPromote(user, promotion)
      && promotion.approvalStatus !== 130
}

export async function userLogout(): Promise<string | null> {
  try {
    await logout()
    clearLocalStorage()
    return null
  } catch (error: any) {
    console.log(error)
    return unwrapDataError(error)
  }
}
